import util from 'util';
import { DEFAULT_DOMAIN } from './constants';

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const log = (...args: any[]) => {
  console.log(util.inspect(args, { showHidden: false, depth: null, colors: true }));
};

/**
 * Generates a canonical URL for the current page
 * @param slug - The page slug (can be empty for home page)
 * @returns The full canonical URL
 */
export function generateCanonicalUrl(slug?: string): string {
  // Remove trailing slash from base URL if present
  const cleanBaseUrl = DEFAULT_DOMAIN.replace(/\/$/, '');

  // Build the path
  let path = '';
  if (slug && slug !== `home`) {
    // For non-home pages, use the slug as the path
    const cleanSlug = slug.replace(`home`, '').replace(/^\/+/, '');
    if (cleanSlug) {
      path = `/${cleanSlug}`;
    }
  }

  return `${cleanBaseUrl}${path}`;
}
